import { createElement } from 'react';
import { ReactComponent as BoxClosedBlueRotatedIcon } from '../../../assets/box-closed-blue-rotated.svg';
import { ReactComponent as DocumentsFolderBlueIcon } from '../../../assets/documents-folder-blue.svg';

export const sideValidatorMax =
  (limit: number | undefined) => (value: number | undefined) => {
    if (value === undefined) return true;
    if (!limit) return false;
    return value <= limit;
  };

export const sideValidatorMin =
  (limit: number) => (value: number | undefined) => {
    if (value === undefined) return true;
    if (!limit) return false;
    return value >= limit;
  };

interface ShipmentTypeUIInfo {
  transKey: string;
  icon: React.ReactNode;
}

export const ShipmentTypeToTranslationMap: Record<string, ShipmentTypeUIInfo> =
  {
    parcel: {
      transKey: 'parcel_content_DHL_items',
      icon: createElement(BoxClosedBlueRotatedIcon),
    },
    document: {
      transKey: 'parcel_content_DHL_documents',
      icon: createElement(DocumentsFolderBlueIcon),
    },
  };
